import { FC, ReactNode } from 'react';

type Props = {
  label: string;
  children: ReactNode;
};

/** Строка показателя понятия: подпись слева, значение справа. */
export const MetaRow: FC<Props> = ({ label, children }) => (
  <div className="flex items-center justify-between gap-4">
    <span className="text-sm text-muted-foreground">{label}</span>
    <span className="text-sm text-foreground">{children}</span>
  </div>
);
